import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { PieChart as PieChartIcon } from 'lucide-react';
const COLORS = ['#6366f1', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316'];
export function IssueDistributionArtifact({
  data
}: {
  data: any[];
}) {
  if (!Array.isArray(data) || data.length === 0) return null;
  const chartData = useMemo(() => {
    const statusCount: Record<string, number> = {};
    data.forEach(issue => {
      const status = issue.fields?.status?.name || issue.status || 'Unknown';
      statusCount[status] = (statusCount[status] || 0) + 1;
    });
    return Object.entries(statusCount).map(([name, value]) => ({
      name,
      value
    })).sort((a, b) => b.value - a.value);
  }, [data]);
  const total = data.length;
  return <div className="p-4 bg-slate-900 rounded-xl border border-slate-800" data-id="element-220">
      <div className="flex items-center justify-between mb-6 border-b border-slate-800/50 pb-4" data-id="element-221">
        <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2" data-id="element-222">
          <PieChartIcon size={16} className="text-indigo-400" data-id="element-223" />
          Distribución por Estado
        </h3>
        <span className="text-xs font-medium text-slate-400 bg-slate-950 px-2 py-1 rounded-md border border-slate-800" data-id="element-224">
          Total: {total} issues
        </span>
      </div>

      <div className="h-64 w-full" data-id="element-225">
        <ResponsiveContainer width="100%" height="100%" data-id="element-226">
          <PieChart data-id="element-227">
            <Pie data={chartData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" stroke="none" data-id="element-228">
              {chartData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-229" />)}
            </Pie>
            <Tooltip contentStyle={{
            backgroundColor: '#0f172a',
            borderColor: '#1e293b',
            borderRadius: '0.5rem',
            color: '#f1f5f9',
            fontSize: '12px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.5)'
          }} itemStyle={{
            color: '#e2e8f0'
          }} formatter={(value: number) => [`${value} issues (${Math.round(value / total * 100)}%)`, 'Cantidad']} data-id="element-230" />

            <Legend verticalAlign="bottom" height={36} iconType="circle" wrapperStyle={{
            fontSize: '12px',
            color: '#94a3b8',
            paddingTop: '20px'
          }} data-id="element-231" />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-232">
        {chartData.map((item, idx) => <div key={item.name} className="flex items-center justify-between bg-slate-950 p-2 rounded-lg border border-slate-800/50" data-id="element-233">
            <div className="flex items-center gap-2" data-id="element-234">
              <div className="w-2.5 h-2.5 rounded-full" style={{
            backgroundColor: COLORS[idx % COLORS.length]
          }} data-id="element-235" />

              <span className="text-xs text-slate-300 truncate max-w-[80px]" title={item.name} data-id="element-236">
                {item.name}
              </span>
            </div>
            <span className="text-xs font-bold text-slate-100" data-id="element-237">
              {item.value}
            </span>
          </div>)}
      </div>
    </div>;
}